<script lang="ts">
  import Layout from "$app/Layouts/Simple.svelte"
  import BottomCta from "$app/Pages/Static/BottomCta.svelte"
  import PlanCertification from "./PlanCertification.svelte"

  let props = $props()
  let certification: any = props.certification

  import team_high5_img from "@images/home/team_high5.jpg"
  import team_culture from "@images/recognitions/team_culture.jpg"
</script>

<Layout {...props}>
  <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8 pb-8">
    <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-5xl">
      <h1
        class="text-3xl lg:text-5xl py-2 mt-6 text-center font-bold text-lwp-theme-blue"
      >
        Certifications
      </h1>

      <div
        class="flex w-100 lg:w-3/4 mx-auto justify-center items-center mt-10"
      >
        <ul class="gap-y-4 w-full">
          <PlanCertification {certification} />
        </ul>
      </div>
    </div>
  </div>

  <div
    class="mt-12 md:mt-16 py-8 lg:py-16 bg-gradient-to-b from-gray-700 to-lwp-theme-blue"
  >
    <div class="relative">
      <div
        class="max-w-3xl mx-auto px-4 sm:px-6 py-4 lg:py-6 relative rounded-xl border bg-lwp-pale-grey shadow-lg border-lwp-theme-blue"
      >
        <h1
          class="text-center text-2xl font-extrabold tracking-tight sm:text-3xl lg:text-4xl"
        >
          <span class="block text-lwp-theme-blue"
            >You can Engage, Empower, and Encourage your entire team through the
            Lead With Purpose framework.</span
          >
        </h1>
        <div
          class="mt-10 max-w-sm mx-auto sm:max-w-none sm:flex sm:justify-center"
        >
          <div class="mx-auto">
            <a
              href="/signup"
              class="flex items-center justify-center px-4 py-4 border border-transparent text-base font-bold shadow text-white bg-green-600 hover:bg-green-500 sm:px-8 rounded-xl"
            >
              Start Your Free Plan Today!
            </a>
          </div>
        </div>
      </div>
      <div
        class="mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl pt-20"
      >
        <div class="mx-auto lg:max-w-5xl">
          <h2
            class="text-3xl md:text-4xl lg:text-6xl font-bold text-center text-white"
          >
            Do you have an E3 Culture?
          </h2>

          <div class="mt-4 py-8 grid grid-cols-1 md:grid-cols-12 gap-4">
            <div class="lg:col-span-5">
              <p class="text-gray-100 mt-8 text-lg lg:text-2xl text-left">
                When your team is engaged, empowered, and encouraged, your
                organization's world-class culture with confident leaders at
                every level will thrive. This results in being 9x more aligned
                and leads up to a 400% increase in company value.
              </p>
            </div>
            <div class="lg:col-span-7 flex justify-center">
              <img
                src={team_culture}
                class="w-auto h-70 object-cover mx-auto shadow-lg rounded-lg"
                alt="Team Culture"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="py-16 mx-auto max-w-7xl px-4 sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-6xl headline relative"
    >
      <div class="w-72 absolute -top-16 right-20 md:right-0 -rotate-12">
        <div class="relative">
          <div class="absolute inset-0">
            <svg
              preserveAspectRatio="none"
              data-bbox="20.5 27.5 159 145"
              viewBox="20.5 27.5 159 145"
              height="200"
              width="200"
              xmlns="http://www.w3.org/2000/svg"
              data-type="shape"
              role="presentation"
              aria-hidden="true"
              class="w-full h-full object-cover"
            >
              <g>
                <path
                  d="M20.5 89.133c0-36.546 18.16-61.524 50.586-61.633h52.748c31.454 0 55.666 19.247 55.666 61.849V172.5s-18.16-28.114-56.639-25.951H71.194c-32.534 0-50.694-24.978-50.694-57.416z"
                />
              </g>
            </svg>
          </div>

          <div class="relative">
            <div class="pt-8 pb-20 px-8">
              <p class="text-base uppercase text-green-500 text-center">
                DID YOU KNOW?
              </p>

              <p
                class="mt-1 text-lg uppercase leading-8 text-white text-center"
              >
                U.S. EMPLOYEE ENGAGEMENT DROPPED FOR THE FIRST TIME IN 10 YEARS
                IN 2022
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-16 lg:mt-24 py-12 grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div>
          <p class="text-4xl lg:text-5xl font-bold text-white">
            Forged by the sea.
          </p>
          <p class="mt-4 text-4xl lg:text-5xl font-bold text-white">
            Tailored for land.
          </p>

          <p class="mt-8 text-xl max-w-sm text-white">
            The Lead With Purpose platform was born from over 35 years of
            founder Marc Koehler's battle-tested leadership experience as both a
            US Nuclear Submarine Officer and turnaround CEO.
          </p>

          <div class="mt-8">
            <a
              href="/about-marc"
              class="font-bold py-4 px-10 shadow text-white bg-green-600 hover:bg-green-500 font-bold rounded-xl"
              >About Marc</a
            >
          </div>
        </div>
        <div>
          <iframe
            src="https://player.vimeo.com/video/800672609?h=50c5ace58f"
            style="aspect-ratio: 16/9; width: 100%;"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowfullscreen
            title="Lead With Purpose Certifications"
          ></iframe>
        </div>
      </div>
    </div>
  </div>

  <div class="relative -mb-32 md:-mb-40 lg:-mb-48 h-86 lg:h-128">
    <img
      class="absolute inset-0 h-full w-full object-cover object-center"
      src={team_high5_img}
      alt="Team High 5"
    />
  </div>

  <BottomCta />
</Layout>
